import React, { useState } from 'react';
import { motion } from 'framer-motion';

export const CICDIcon: React.FC = () => {
	const [hovered, setHovered] = useState(false);
	return (
		<svg
			width="93"
			height="45"
			viewBox="0 0 93 45"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			<path
				d="M66.87 19.9326L64.1543 22.6597L66.7905 25.2959"
				stroke="#F27C00"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M73.5859 25.2959L76.313 22.5802L73.6655 19.9326"
				stroke="#F27C00"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M70.9159 19.9326L69.541 25.2959"
				stroke="#F27C00"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<motion.path
				d="M3.56821 31.7959C2.12512 28.9551 1.31836 25.7508 1.31836 22.3533C1.31836 10.8086 10.7041 1.42285 22.2488 1.42285C29.6801 1.42285 36.4865 6.28617 43.0315 12.2971L36.6797 13.5811L37.4864 19.9671C32.1004 14.8992 26.8053 10.82 22.2602 10.82C15.8969 10.82 10.7268 15.9901 10.7268 22.3533C10.7268 23.8759 11.0223 25.3304 11.5677 26.6712L9.95415 32.9549L3.59094 31.7959H3.56821Z"
				fill="#F27C00"
				stroke="#F27C00"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				animate={hovered ? { fillOpacity: 1 } : { fillOpacity: 0 }}
				transition={{ duration: 0.3 }}
			/>
			<path
				d="M9.93122 32.9438L11.5447 26.6602C13.2605 30.8871 17.408 33.887 22.2486 33.887C25.9983 33.887 30.4185 30.944 34.8614 27.0919L41.3155 27.9555L41.2473 34.0688C35.4977 39.0457 28.9981 43.2727 22.2372 43.2727C14.09 43.2727 7.01096 38.5912 3.55664 31.7848L9.91986 32.9438H9.93122Z"
				stroke="#F27C00"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<motion.path
				d="M78.3699 31.2732C80.9493 29.1597 82.5855 25.944 82.5855 22.3646C82.5855 16.0014 77.4154 10.8313 71.0522 10.8313C69.3364 10.8313 67.4956 11.4222 65.5866 12.4335L66.3707 6.0021L60.1211 4.74081C63.6095 2.72958 67.2684 1.42285 71.0636 1.42285C82.6082 1.42285 91.994 10.8086 91.994 22.3533C91.994 29.0688 88.8124 35.0684 83.8695 38.8977L77.5745 37.625L78.3699 31.2618V31.2732Z"
				fill="#F27C00"
				stroke="#F27C00"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				animate={hovered ? { fillOpacity: 1 } : { fillOpacity: 0 }}
				transition={{ duration: 0.3 }}
			/>
			<path
				d="M43.0319 12.3086C45.3613 14.4562 47.6793 16.706 49.9519 18.9786C50.5769 19.5922 53.3608 22.3307 53.3608 22.3307C59.599 28.4325 65.8031 33.864 71.0869 33.864C73.8594 33.864 76.4047 32.8754 78.4046 31.2392L77.5864 37.6365L83.9042 38.875C80.359 41.6248 75.9161 43.2611 71.0982 43.2611C60.9739 43.2611 51.9972 34.2958 43.3273 25.6259C41.3956 23.7056 39.4299 21.7966 37.4982 19.9785L36.6914 13.5926L43.0433 12.3086H43.0319Z"
				stroke="#F27C00"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M66.3705 5.99077L67.1151 6.08039C67.1619 5.69204 66.9023 5.33298 66.5189 5.2556L66.3705 5.99077ZM60.1209 4.72949L60.2693 3.99431L59.9911 3.93816L59.7454 4.08028L60.1209 4.72949ZM46.6445 15.7288L46.1202 15.1925L45.5746 15.726L46.1174 16.2623L46.6445 15.7288ZM53.3373 22.342L52.8101 22.8755L53.3353 23.3944L53.8624 22.8775L53.3373 22.342ZM65.5978 12.4108L65.9493 13.0734L66.2956 12.8897L66.3425 12.5004L65.5978 12.4108ZM66.5189 5.2556L60.2693 3.99431L59.9725 5.46467L66.2221 6.72595L66.5189 5.2556ZM59.7454 4.08028C54.8037 6.93885 50.2109 11.1927 46.1202 15.1925L47.1689 16.265C51.2594 12.2653 55.7343 8.1334 60.4965 5.3787L59.7454 4.08028ZM46.1174 16.2623L52.8101 22.8755L53.8644 21.8085L47.1717 15.1953L46.1174 16.2623ZM53.8624 22.8775C57.98 18.8395 62.137 15.0955 65.9493 13.0734L65.2464 11.7482C61.2183 13.8849 56.9213 17.7768 52.8121 21.8065L53.8624 22.8775ZM66.3425 12.5004L67.1151 6.08039L65.6259 5.90115L64.8532 12.3212L66.3425 12.5004Z"
				fill="#F27C00"
			/>
			<path
				d="M24.453 22.3417C24.453 22.5488 24.2851 22.7167 24.0781 22.7167C23.871 22.7167 23.7031 22.5488 23.7031 22.3417C23.7031 22.1347 23.871 21.9668 24.0781 21.9668C24.2851 21.9668 24.453 22.1347 24.453 22.3417Z"
				fill="#F27C00"
				stroke="#F27C00"
			/>
			<path
				d="M21.8632 22.3417C21.8632 22.5488 21.6953 22.7167 21.4882 22.7167C21.2811 22.7167 21.1133 22.5488 21.1133 22.3417C21.1133 22.1347 21.2811 21.9668 21.4882 21.9668C21.6953 21.9668 21.8632 22.1347 21.8632 22.3417Z"
				fill="#F27C00"
				stroke="#F27C00"
			/>
			<path
				d="M27.1346 22.3417C27.1346 22.5488 26.9668 22.7167 26.7597 22.7167C26.5526 22.7167 26.3848 22.5488 26.3848 22.3417C26.3848 22.1347 26.5526 21.9668 26.7597 21.9668C26.9668 21.9668 27.1346 22.1347 27.1346 22.3417Z"
				fill="#F27C00"
				stroke="#F27C00"
			/>
			<path
				d="M20.1469 18.7168H18.6016V25.9663H20.1469"
				stroke="#F27C00"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M28.1914 25.9663H29.7368V18.7168H28.1914"
				stroke="#F27C00"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};
